enum QueryKeys {
  gamesRecent = 'GAMES_RECENT',
  allGames = 'GAMES_ALL',
  singleGame = 'SINGLE_GAME',
  totalPages = 'TOTAL_PAGES',
  primaryBanner = 'PRIMARY_BANNER',
  secondaryBanner = 'SECONDARY_BANNER',
  product = 'PRODUCT',
  orders = 'ORDERS',
  countries = 'COUNTRIES',
}

export default QueryKeys;
